<template>
    <button 
        class="btn btn-vigo-1-500 rounded rounded-pill px-3 py-2 d-flex align-items-center justify-content-center" 
        data-shake
    >
        Jetzt online abschließen
        <span class="ms-3 mb-1">
            <OnlineAbschliessenIcon/>
        </span>
    </button>
</template>

<script setup>
import OnlineAbschliessenIcon from '@/components/icons/online_abschliessen_icon.vue';
</script>